import axios from 'axios';
const Config = require('~config/default.env').default;

const BASE = Config.SOCO_LINK_API_URL;

const USER_ME = `${BASE}/user/me`;

const getAffiliateInfo = () => axios.get(`${USER_ME}/affiliates`);

const serializeFilterParams = (params = {}) => {
  const { filter, ...rest } = params;
  return {
    ...rest,
    ...(filter ? { filter: JSON.stringify(filter) } : {}),
  };
};

const getAffiliatePromotedProducts = (params = {}) =>
  axios.get(`${USER_ME}/promoted-products`, {
    params: serializeFilterParams(params),
  });

const getAffiliatePromotedProductsCount = (params = {}) =>
  axios.get(`${USER_ME}/promoted-products/counts`, {
    params: serializeFilterParams(params),
  });

const getAffiliateOrderList = (params = {}) =>
  axios.get(`${Config.MS_ORDER_API_URL}/user/me/affiliate-orders`, {
    params: serializeFilterParams(params),
  });

const registerAffiliate = (payload) =>
  axios.post(`${USER_ME}/affiliates`, payload);

const updateAffiliate = (payload) =>
  axios.put(`${USER_ME}/affiliates`, payload);

const checkIdentity = (identity_number) =>
  axios.get(`${BASE}/affiliates/check-identity`, {
    params: { identity_number },
  });

const getProductCommission = (ids) => {
  const params = {};
  (ids || []).forEach((item, i) => {
    params[`filter[ids][${i}][id]`] = item.id;
    params[`filter[ids][${i}][qty]`] = item.qty ?? 1;
    if (item.combination_id) {
      params[`filter[ids][${i}][combination_id]`] = item.combination_id;
    }
  });
  return axios.get(`${BASE}/promoted-products/commission`, { params });
};

const submitPromotedProduct = (product_id) =>
  axios.post(`${USER_ME}/promoted-products`, { product_id });

const getUserPromotedProducts = (params) =>
  axios.get(`${USER_ME}/promoted-products`, { params });

const clickPromotedProduct = (affiliates_product_id) =>
  axios.put(`${BASE}/promoted-products/${affiliates_product_id}/clicks`);

export default {
  getAffiliateInfo,
  registerAffiliate,
  updateAffiliate,
  checkIdentity,
  getProductCommission,
  submitPromotedProduct,
  getUserPromotedProducts,
  clickPromotedProduct,
  getAffiliatePromotedProducts,
  getAffiliatePromotedProductsCount,
  getAffiliateOrderList,
};
